"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var LvFalconNavigator_1 = require("./LvFalconNavigator");
var LvFalconNavigatorNoBackground = /** @class */ (function (_super) {
    __extends(LvFalconNavigatorNoBackground, _super);
    function LvFalconNavigatorNoBackground(props) {
        var _this = _super.call(this, props) || this;
        _this.showTitle = false;
        return _this;
    }
    return LvFalconNavigatorNoBackground;
}(LvFalconNavigator_1.default));
exports.default = LvFalconNavigatorNoBackground;
//# sourceMappingURL=LvFalconNavigatorNoTitle.js.map